export enum ComplaintEntityType {
  SERVICE = 0,
  MAP = 1,
  EVENT = 2,
  VACANCY = 3,
  COURSE = 4,
  NEWS = 5,
  FEEBACKS = 6,
  CONTACTS = 7,
  KB_MATERIAL = 8,
  CONTACTS_CARD = 9
}
